import React, { useState } from 'react'
import { Dialog } from '@headlessui/react'
import { Oval } from  'react-loader-spinner'

export default function SaveDraftModal({saveDraftModal,setSaveDraftModal, handleCreateAuction,loader, auctionData}) {
    const [disableSaveButton, setDisableSaveButton] = useState(false)

    return (
        <Dialog open={saveDraftModal} onClose={() => setSaveDraftModal(false)}
            data-te-modal-init
            className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-[#282828cc]"
            id="exampleModalXl3"
            tabIndex="-1"
            aria-labelledby="exampleModalXlLabel"
            aria-modal="true"
            role="dialog">
            <Dialog.Panel
                data-te-modal-dialog-ref
                className="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] 
                    items-center mx-3 transition-all duration-300 ease-in-out min-[640px]:mx-auto 
                    min-[640px]:mt-7 min-[640px]:min-h-[calc(100%-3.5rem)] min-[640px]:max-w-[658px]">
                <div
                    className="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white 
                    bg-clip-padding text-current shadow-lg outline-none">
                    <Dialog.Title
                        className="flex flex-shrink-0 items-center justify-end rounded-t-md p-3">
                        {/* <!--Close button--> */}
                        <button onClick={()=>setSaveDraftModal(false)}
                            type="button"
                            className="box-content rounded-none border-none"
                            data-te-modal-dismiss
                            aria-label="Close">
                            <img src="/images/CloseButton-modalcontent.svg" alt="img" />
                        </button>
                    </Dialog.Title>
                    {/* <!--Modal body--> */}
                    <div className="relative">
                        {(!auctionData.status || auctionData.status==="Draft") && 
                            <p className=" px-6 text-center pb-4 leading-normal 
                        text-[22px] text-[#343434] font-medium">Save to your drafts?</p>}
                        {(auctionData.status==="Published" || auctionData.status==="Accepting bids") && 
                        <p className=" px-6 text-center pb-4 leading-normal 
                        text-[22px] text-[#343434] font-medium">Save your auction?</p>}
                        {(!auctionData.status || auctionData.status==="Draft") && 
                        <p className=" px-[50px] text-center pb-4 leading-normal 
                            text-[16px] text-[#A1A1A9] font-medium">Once saved, you can upload auction lots, 
                            make design edits, and publish the auction whenever you are ready to view it.</p>}
                        <div className="flex justify-center pb-[47px]">
                            <button type='button' onClick={()=>setSaveDraftModal(false)}
                                className="px-[31px] py-[12px] border esm:w-[135px] w-[100px] border-[#A1A1A9] 
                            bg-[#fffff] text-[#282828] leading-normal font-medium text-[14px] rounded-[6px]
                                hover:bg-[#EFF1F8]"  
                                data-te-modal-dismiss
                                aria-label="Cancel">
                                Cancel
                            </button>
                            <button id='save-draft' 
                                type='button' onClick={(e)=>{setDisableSaveButton(false),handleCreateAuction(e)}}
                                disabled={disableSaveButton || loader }
                                className="flex ml-3 justify-center items-center px-[31px] esm:w-[135px] w-[100px] py-[12px] 
                                    bg-[#282828] text-[#FFFFFF] leading-normal font-medium text-[14px] rounded-[6px] 
                                    disabled:bg-[#D4D4D8] disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto 
                                    hover:bg-[#626465]" 
                                data-te-modal-dismiss
                                aria-label="Save">
                                Save
                                {loader&& 
                                    <Oval
                                        height={20}
                                        width={50}
                                        color="#FFFFFF"
                                        wrapperClass=""
                                        visible={true}
                                        ariaLabel='oval-loading'
                                        secondaryColor="#000000"
                                        strokeWidth={2}
                                        strokeWidthSecondary={2}
                                    />
                                }
                            </button>
                            
                        </div>
                    </div>
                </div>
            </Dialog.Panel>
        </Dialog>  
    )
}
